import React from "react";
import Checkbox from "@material-ui/core/Checkbox";
import classes from "./Item.module.css";

const Item = (props) => {
  const active = props.tags[props.index].status === "active" ? true : false;
  return (
    <div className={classes.Item}>
      <Checkbox
        className={classes.CheckboxDesktop}
        checked={active}
        onChange={(event) => props.onChange(props.index, event.target.checked)}
      />
      <h3>{props.title}</h3>
      <Checkbox
        className={classes.CheckboxMobile}
        checked={active}
        onChange={(event) => props.onChange(props.index, event.target.checked)}
      />
      <p>{props.description}</p>
    </div>
  );
};

export default Item;
